import React from 'react';

import './layout.scss';

export function Well(props) {
  let classNames = 'well ';
  if (props.warning) classNames += 'warning ';
  if (props.alert) classNames += 'alert ';
  if (props.info) classNames += 'info ';
  if (props.center) classNames += 'center ';
  if (props.success) classNames += 'success ';
  if (props.message) classNames += 'message ';
  return <div className={`${classNames} ${props.className || ''} ${props.error ? ' error ' : ''}`}>{props.children}</div>;
}
